import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface CheckUserExistsResponse {
  exists: boolean;
}

export function useCheckUserExists(
  email: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKeys.user.exists(email),
    queryFn: async () => {
      const response = await api
        .get('user/exists', { searchParams: { email } })
        .json<CheckUserExistsResponse>();
      return response;
    },
    enabled: options?.enabled ?? false,
    retry: false,
  });
}
